import React, { useState } from "react"
import PropTypes from "prop-types"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText
} from "@mui/material"
import { FaTimes } from "react-icons/fa"
import moment from "moment"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}))

const BootstrapDialogTitle = props => {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <FaTimes />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
}

export default function IpAddressesModal({ ipAddresses, onClose }) {
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
    onClose && onClose()
  }

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby='ip-addresses-dialog-title'
      open={open}
      maxWidth='sm'
      fullWidth
    >
      <BootstrapDialogTitle id='ip-addresses-dialog-title' onClose={handleClose}>
        IP Addresses
      </BootstrapDialogTitle>
      <DialogContent dividers>
        {!ipAddresses || ipAddresses.length === 0 ? (
          <Typography variant='body1' color='text.secondary'>
            No IP addresses recorded.
          </Typography>
        ) : (
          <List dense>
            {ipAddresses.map((entry, index) => (
              <ListItem key={index} divider={index !== ipAddresses.length - 1}>
                <ListItemText
                  primary={entry.ip}
                  secondary={`First seen: ${moment(entry.firstSeen).format("DD-MM-YYYY HH:mm")}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}
